export default __webpack_public_path__ + "static/media/Gallery-11.13f900a1.jpeg";